import * as NotificationsTypes from '../actionTypes/NotificationDetailsActionTypes';

export const getNotification = (params) => ({
    type: NotificationsTypes.GET_NOTIFICATION,
    payload: params,
});

export const updateNotification = (params) => ({
    type: NotificationsTypes.UPDATE_NOTIFICATION,
    payload: params,
});
